import { SLA_SUPPORT_PROJECT_TYPE_ID } from '../../constants/typeIds';
import type { ProjectTypeTone as Tone } from '../../components/ui/TypePill';

/**
 * Phase 41 Plan 41-10 Task 2 (TYPE-03 surfacing) — projectTypeId → TypePill tone mapper.
 *
 * Used by ProjectListPage's TypePill column. Per checker I-13, the SLA
 * discriminator imports `SLA_SUPPORT_PROJECT_TYPE_ID` from
 * `frontend/src/constants/typeIds.ts` instead of hardcoding the literal `2`,
 * so a backend ID change updates one frontend file (the constants module
 * is contract-tested against the backend literal in
 * `tests/unit/constants-typeIds.test.ts`).
 *
 * Mapping (locked):
 *   - id === SLA_SUPPORT_PROJECT_TYPE_ID  → tone='sla'    + label='SLA'
 *   - id null / undefined / 1 (baseline)  → tone='default' + label='Default'
 *   - any other id (future types)          → tone='mixed'   + label='Mixed'
 */
export function projectTypeTone(
  projectTypeId: number | null | undefined,
): { tone: Tone; label: string } {
  if (projectTypeId === SLA_SUPPORT_PROJECT_TYPE_ID) {
    return { tone: 'sla', label: 'SLA' };
  }
  if (projectTypeId == null || projectTypeId === 1) {
    return { tone: 'default', label: 'Default' };
  }
  return { tone: 'mixed', label: 'Mixed' };
}
